import React from 'react'

import WopiSetup from './WopiSetup'
import WopiStart from './WopiStart'
import WopiQuestions from './WopiQuestions'

export default class WopiQuestionnaire extends React.Component {
  render() {
    const {
      isStarted,
      questions,
      personalInformation,
      activeQuestionIndex,
      activeSetupPhase,
      goToNextPhase,
      language,
      answerWopiQuestion,
      startQuestionnaire,
      activeQuestionAnswer,
      submitPersonalAndStatisticalInformation,
      uuid,
      refreshQuestionnaire
    } = this.props

    const amountOfSetupPhases = 3

    if (activeSetupPhase < amountOfSetupPhases && personalInformation == null) {
      return (
        <WopiSetup
          uuid={uuid}
          goToNextPhase={goToNextPhase}
          activeSetupPhase={activeSetupPhase}
          language={language}
          submitPersonalAndStatisticalInformation={submitPersonalAndStatisticalInformation}
        />
      )
    }

    if (isStarted == false) {
      return <WopiStart uuid={uuid} onStart={startQuestionnaire} language={language} />
    }

    return (
      <WopiQuestions
        uuid={uuid}
        language={language}
        questions={questions}
        activeQuestionIndex={activeQuestionIndex}
        activeQuestionAnswer={activeQuestionAnswer}
        onAnswer={answerWopiQuestion}
        refreshQuestionnaire={refreshQuestionnaire}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiQuestionnaire.js